import { useQuery, useMutation, useQueryClient } from "react-query";
import { getCustomer, saveCustomer, importExcel, exportExcel } from "@/api/Customer/customer-form-api";

const key = "customer-form";

export function useCustomer(params) {
	return useQuery([key, params], () => getCustomer(params));
}

export function useCustomerSave(params) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params) => saveCustomer(params),
		onSuccess: (response) => {
			queryClient.invalidateQueries("dashboard_filters");

			const newSeasons = response?.customer?.seasons || [];

			queryClient.setQueryData([key, params], (oldData) => {
				if (!oldData) return oldData;
				return {
					...oldData,
					customer: {
						...oldData.customer,
						seasons: newSeasons,
					},
				};
			});
		},
	});
}

export function useCustomerExcelImport() {
	return useMutation({
		mutationFn: importExcel,
	});
}

export function useCustomerExcelExport() {
	return useMutation({
		mutationFn: exportExcel,
	});
}
